import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import Sidebar from './components/Layout/Sidebar';
import Header from './components/Layout/Header';
import AuthGuard from './components/AuthGuard';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import AdminManagement from './pages/AdminManagement';
import ReferralManagement from './pages/ReferralManagement';
import ProfitManagement from './pages/ProfitManagement';
import CalculationManagement from './pages/CalculationManagement';
import DataAnalytics from './pages/DataAnalytics';
import SystemSettings from './pages/SystemSettings';
import OperationLogs from './pages/OperationLogs';
import VerificationManagement from './pages/VerificationManagement';
import { APP_CONFIG } from './config';

const { Content } = Layout;

const App: React.FC = () => {
  // 检查是否已登录
  const isAuthenticated = localStorage.getItem(APP_CONFIG.tokenKey);
  const userStr = localStorage.getItem(APP_CONFIG.userKey);
  const user = userStr ? JSON.parse(userStr) : null;

  console.log('[App] isAuthenticated:', !!isAuthenticated);
  console.log('[App] user:', user);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {isAuthenticated && <Sidebar />}
      <Layout>
        {isAuthenticated && <Header />}
        <Content style={{ 
          margin: isAuthenticated ? '0' : '0', 
          padding: isAuthenticated ? '24px' : '0', 
          background: '#f0f2f5',
          overflow: 'auto' 
        }}>
          <Routes>
            <Route path="/login" element={<Login />} />
            
            {!isAuthenticated ? (
              <Route path="*" element={<Navigate to="/login" replace />} />
            ) : (
              <>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/calculation" element={<CalculationManagement />} />
                <Route
                  path="/users"
                  element={
                    <AuthGuard>
                      <UserManagement />
                    </AuthGuard>
                  }
                />
                <Route
                  path="/admins"
                  element={
                    <AuthGuard requireSuperAdmin>
                      <AdminManagement />
                    </AuthGuard>
                  }
                />
                <Route
                  path="/referrals"
                  element={
                    <AuthGuard>
                      <ReferralManagement />
                    </AuthGuard>
                  }
                />
                <Route
                  path="/profit"
                  element={
                    <AuthGuard>
                      <ProfitManagement />
                    </AuthGuard>
                  }
                />
                <Route
                  path="/analytics"
                  element={
                    <AuthGuard>
                      <DataAnalytics />
                    </AuthGuard>
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <AuthGuard>
                      <SystemSettings />
                    </AuthGuard>
                  }
                />
                <Route
                  path="/logs"
                  element={
                    <AuthGuard requireSuperAdmin>
                      <OperationLogs />
                    </AuthGuard>
                  }
                />
                <Route
                  path="/verification"
                  element={
                    <AuthGuard>
                      <VerificationManagement />
                    </AuthGuard>
                  }
                />
              </>
            )}
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
